<script setup>
import { ref, watch, defineProps } from 'vue';
import { useCommonData } from '@/hooks';

defineProps({
	quarterDetails: {
		type: Object,
		default: () => ({})
	}
});

const { getUpperThemeColor } = useCommonData();

// 摘要图片逻辑
const summaryImg = ref('');
watch(
	() => getUpperThemeColor.value,
	color => {
		if (color) {
			summaryImg.value = require(`@/assets/images/home/quarterly_summary_normal.png`);
		}
	},
	{ immediate: true }
);
</script>

<template>
	<div class="quarter-flex-2 quarter-footer mt-48" v-if="quarterDetails.summarize">
		<div class="quarter-footer-banner">
			<el-image :src="summaryImg" fit="cover" class="summary-img"></el-image>
			<MixColorMask />
		</div>
		<div class="quarter-footer-content" v-html="quarterDetails.summarize"></div>
	</div>
</template>

<style lang="less" scoped>
.quarter {
	&-flex-2 {
		width: 100%;
	}
	&-footer {
		padding: 32px 24px;
		background: #ffffff;
		display: flex;
	}
	&-footer-banner {
		width: 214px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		position: relative;
		p {
			color: #fff;

			font-size: 24px;

			font-weight: 600;
			line-height: 140%; /* 33.6px */
			position: relative;
		}
	}
	&-footer-content {
		margin-left: 24px;
		flex: 1;
		/deep/ ol li {
			list-style: auto;
			list-style-position: inside;
		}
		/deep/ ul li {
			list-style: inside;
		}
	}
}
</style>
